import { TruncatedText } from "@via/components/truncated-text.tsx";
import { DataSource, DataSourceProvider } from "common";
import S3Logo from "/aws-s3-logo.svg";
import GCSLogo from "/gcs-logo.svg";
import ClusterServerLogo from "/cluster-server-logo.svg";
import GeoLogo from "/geo-logo.png";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import React, { FC } from "react";
import BaseSpaceLogo from "/basespace-logo.png";

const UrlLogoComponent: FC = () => (
  <div className="flex items-center">
    <GlobeAltIcon className="mr-2 h-4 w-4" aria-label="URL Logo" />
    <span className="max-w-42 overflow-hidden text-ellipsis whitespace-nowrap font-semibold">
      URL
    </span>
  </div>
);

const GeoLogoComponent: FC = () => (
  <div className="flex items-center">
    <img className="mr-2 h-4 w-4" alt={`Geo Logo`} src={GeoLogo} />
    <span className="max-w-42 overflow-hidden text-ellipsis whitespace-nowrap font-semibold">
      Geo
    </span>
  </div>
);

const logoMap: {
  [key in DataSourceProvider]?: string | FC;
} = {
  [DataSourceProvider.Amazon]: S3Logo,
  [DataSourceProvider.Google]: GCSLogo,
  [DataSourceProvider.SSH]: ClusterServerLogo,
  [DataSourceProvider.URL]: UrlLogoComponent,
  [DataSourceProvider.GEO]: GeoLogoComponent,
  [DataSourceProvider.BaseSpace]: BaseSpaceLogo,
};

export const getDataSourceTitle = (
  dataSource: Pick<DataSource, "name"> | null | undefined,
  provider: number,
  tooltipId?: string
) => {
  const logo = logoMap[provider];

  return (
    <div>
      <div className="flex items-center">
        {logo &&
          (typeof logo === "string" ? (
            <img
              className="mr-2 h-4 w-4"
              alt={`${DataSourceProvider[provider] ?? provider} Logo`}
              src={logo}
            />
          ) : (
            React.createElement(logo)
          ))}
        {dataSource?.name && (
          <span className="max-w-42 overflow-hidden text-ellipsis whitespace-nowrap font-semibold">
            <TruncatedText
              text={dataSource.name}
              id={tooltipId ?? `tooltip-cloud${dataSource.name}`}
            />
          </span>
        )}
      </div>
    </div>
  );
};
